// noinspection DuplicatedCode

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import TextField from '@/modules/common/components/TextField';
import DialogForm from '@/modules/common/components/DialogForm';
import { withFetch } from '~/hocs/fetch';

const initialValues = {
    username: '',
    password: '',
    affiliateId: '',
    affiliateName: '',
};

const initialErrors = {
    username: '',
    password: '',
    affiliateId: '',
    affiliateName: ''
};

let abortController;

const DialogAddAffiliate = (props) => {
    const [values, setValues] = useState(initialValues);
    const [errors, setErrors] = useState(initialErrors);
    const [fetching, setFetching] = useState(false);

    const clear = () => {
        setValues(initialValues);
        setErrors(initialErrors);
    };

    useEffect(() => {
        return () => {
            if (abortController) {
                abortController.abort();
            }
        };
    }, []);

    const handleChange = (prop) => (event) => {
        setValues({...values, [prop]: event.target.value});
    };

    const handleFocus = (prop) => () => {
        setErrors({...errors, [prop]: ''});
    };

    const handleSubmit = (event) => {
        abortController = new AbortController();

        event.preventDefault();
        setFetching(true);
        props.fetch.post(
            '/api/affiliates/', {
                username: values.username,
                password: values.password,
                affiliate_id: values.affiliateId,
                affiliate_name: values.affiliateName,
            }, abortController
        ).then(({ok, data}) => {
            if (ok) {
                clear();
                props.onOk(data);
            }
            else {
                let _errors = {...initialErrors};
                _errors.username = (data.username) ? data.username[0] : '';
                _errors.password = (data.password) ? data.password[0] : '';
                _errors.affiliateId = (data.affiliate_id) ? data.affiliate_id[0] : '';
                _errors.affiliateName = (data.affiliate_name) ? data.affiliate_name[0] : '';
                setErrors(_errors);
            }
            setFetching(false);
        }).catch((error) => {
            if (error.name !== 'AbortError') {
                setFetching(false);
            }
        }).finally(() => {
            abortController = null;
        });
    };

    const handleClose = () => {
        clear();
        props.setOpen(false);
    };

    return (
        <DialogForm title="Добавление партнера" label="Добавить"
                    open={props.open} onClose={handleClose}
                    onSubmit={handleSubmit}
                    disabled={fetching}
        >
            <TextField label="Имя пользователя" type="email"
                       value={values.username} onChange={handleChange('username')}
                       error={errors.username.length > 0}
                       helperText={errors.username}
                       onFocus={handleFocus('username')}
                       autoFocus={true}
            />
            <TextField label="Пароль" type="password"
                       value={values.password} onChange={handleChange('password')}
                       error={errors.password.length > 0}
                       helperText={errors.password}
                       onFocus={handleFocus('password')}
            />
            <TextField label="ID партнера" type="number" inputProps={{min: 1}}
                       value={values.affiliateId} onChange={handleChange('affiliateId')}
                       error={errors.affiliateId.length > 0}
                       helperText={errors.affiliateId}
                       onFocus={handleFocus('affiliateId')}
            />
            <TextField label="Название партнера"
                       value={values.affiliateName} onChange={handleChange('affiliateName')}
                       error={errors.affiliateName.length > 0}
                       helperText={errors.affiliateName}
                       onFocus={handleFocus('affiliateName')}
            />
        </DialogForm>
    );
};

DialogAddAffiliate.propTypes = {
    open: PropTypes.bool.isRequired,
    setOpen: PropTypes.func.isRequired,
    onOk: PropTypes.func.isRequired,
};

let Component = DialogAddAffiliate;
Component = withFetch(Component);

export default Component;
